// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-link svg[data-v-ce52fb2e]{margin-right:5px}.nav-link span[data-v-ce52fb2e],.nav-link svg[data-v-ce52fb2e]{vertical-align:middle}.ant-menu-submenu-popup[data-v-ce52fb2e]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
